// SPG (Surat Penerimaan Gudang) Bawang / Kawat / Lain as native ESC/P for the
// Epson LX-310. The three HTML versions are identical except the title, so a
// single factory produces all three builders. Content mirrors the HTML; the
// page layout (boxed table, page numbers, footer) comes from halfFormEscp.js.

import {
  buildHalfFormDoc,
  STANDARD_COLUMNS,
  STANDARD_TOTALS,
} from "./halfFormEscp";

// HTML version falls back to "today" when no date is present.
const fmtDate = (data) => {
  const raw = data.transaction_date || data.created_at;
  const d = raw ? new Date(raw) : new Date();
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
};

const makeSPGEscpBuilder = (titleText) => {
  const config = {
    title: titleText,
    infoLines: (data) => [
      ["Tanggal", fmtDate(data), "No. SJ", data.sj_number || "-"],
      [
        "No. SPG",
        data.document_number || data.sj_number || data.id,
        "Gudang Tujuan",
        data.warehouse_name || "-",
      ],
    ],
    columns: STANDARD_COLUMNS,
    groupHeader: { label: "JUMLAH", span: 2 },
    totalSpan: 5,
    totals: STANDARD_TOTALS,
    notes: (data) => data.notes || "-",
    signatureLabel: "Yang membuat,",
    signatureName: (data) =>
      data.user_username || data.user_email || "(_______________)",
    maxItemsPerPage: 7,
  };
  return (data, itemsPerPage = 7) =>
    buildHalfFormDoc(config, data, itemsPerPage);
};

export const buildSPGBawangEscp = makeSPGEscpBuilder(
  "SURAT PENERIMAAN GUDANG (SPG) BAWANG"
);
export const buildSPGKawatEscp = makeSPGEscpBuilder(
  "SURAT PENERIMAAN GUDANG (SPG) KAWAT"
);
export const buildSPGLainEscp = makeSPGEscpBuilder(
  "SURAT PENERIMAAN GUDANG (SPG) LAIN"
);
